import { render, staticRenderFns } from "./LightSource.vue?vue&type=template&id=6edc0a85&scoped=true"
import script from "./LightSource.vue?vue&type=script&lang=ts"
export * from "./LightSource.vue?vue&type=script&lang=ts"
import style0 from "./LightSource.vue?vue&type=style&index=0&id=6edc0a85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc0a85",
  null
  
)

export default component.exports